import style from "./Paginado.module.css";

const Paginado = ({ paisPorPagina, todoLongitud, paginado }) => {
  const numerosDePagina = []; //Solo Guarda los numeros del paginado
  for (let i = 0; i < Math.ceil(todoLongitud / paisPorPagina); i++) {
    numerosDePagina.push(i + 1);
  }

  return (
    <ul className={style.paginadoContainer}>
      {numerosDePagina?.map((numero) => {
        return (
          <li className={style.li} key={numero}>
            <button className={style.buttons} onClick={() => paginado(numero)}>
              {numero}
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default Paginado;
